import { createAttrDefaultValue } from "../attribute/createAttrDefaultValue";
import { ZSpecification } from "./ZSpecification";

export const createSpecDefaultValues = (
  spec: ZSpecification,
): Record<string, unknown> => {
  const res: Record<string, unknown> = {};
  spec.definition?.attributes.forEach((attr) => {
    res[attr.name] = createAttrDefaultValue(attr.type);
  });
  return res;
};
